import { Box } from '@mui/material';
import {
  TextV2,
  type TextV2Colour,
} from '@insights-ltd/design-library/components';
import { Trans } from 'react-i18next';

const ProfileDates = ({
  completionDate,
  createdDate,
  showPurchaseDate,
  textColor,
}: {
  completionDate: string;
  createdDate?: string;
  showPurchaseDate: boolean;
  textColor?: TextV2Colour;
}) => {
  const boldStyle = {
    bold: <TextV2 variant="bodyBold" component="span" color={textColor} />,
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <TextV2 variant="body1" component="p" color={textColor}>
        <Trans
          i18nKey="ui.event-management.profiles.evaluator-completion-date"
          values={{ date: completionDate }}
          components={boldStyle}
        />
      </TextV2>
      {showPurchaseDate && (
        <TextV2 variant="body1" component="p" color={textColor}>
          <Trans
            i18nKey="ui.event-management.profiles.evaluator-purchased-date"
            values={{ date: createdDate }}
            components={boldStyle}
          />
        </TextV2>
      )}
    </Box>
  );
};
export default ProfileDates;
